module.exports = __webpack_public_path__ + "static/1-d30e3178f7bf043b5449d51198e42698.jpg";